import VistaPesajes from "@/views/VistaPesajes.vue";

const pesajes = {
  path: "/app/pesajes",
  name: "pesajes",
  component: VistaPesajes,
};

export default pesajes;
